// interface
import TServiceBase from "@/core/types/TServiceBase";


class ServiceBase {

    sourcePath: string  = "";
    code: string        = "";

    constructor ( { sourcePath }: TServiceBase ) {
        this.sourcePath = sourcePath
    }

}

export default ServiceBase;
